import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { type ReactNodeViewProps, NodeViewContent } from '@tiptap/react';
import { memo } from 'react';

const DetectAnswerExplanationNodeView: React.FC<ReactNodeViewProps> = ({ decorations }) => {
    return (
        <ZyNodeViewWrapper decorations={decorations}>
            <div className="mt-2 rounded-md border border-gray-200 bg-gray-50 p-2 dark:border-gray-700 dark:bg-gray-900/50">
                <div className="mb-1 text-xs font-semibold text-gray-500 dark:text-gray-400">Explanation</div>
                <NodeViewContent />
            </div>
        </ZyNodeViewWrapper>
    );
};

export default memo(DetectAnswerExplanationNodeView);
